<template>
  <div class="container-fluid px-4">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "Settings"
}
</script>

<style scoped>

</style>
